/**
 * 2019-04-13
 * handan
 * 背调点充值
 */

import React, { Component } from 'react'
import { connect } from "react-redux";
import "./style.scss";

import getQueryString from "../../utils/getQueryString";
import { getRechargeList, chargeAndPay, getPointSum, getPayResult } from "../../models";
import { ModalPop } from "../../components";


class FillingMoney extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rechargeList: [],
      checkedData: {},
      pointSum: 0,
    }
    this.orderId = getQueryString("orderId");
    this.handleSubmitClick = this.handleSubmitClick.bind(this);
    this.getFillingMoneyData = this.getFillingMoneyData.bind(this);
  }
  render() {
    const {
      rechargeList=[], 
      checkedData = {},
      pointSum = 0
    } = this.state
    const { vipInfo = {}, history } = this.props;
    // console.log( JSON.stringify( rechargeList ) )
    // const rechargeList = [
    //   {
    //     "id": 5,
    //     "rechargeName": "220",
    //     "addPoints": 220,
    //     "originalPrice": 1100,
    //     "salePrice": 599,
    //     "discountRate": 5.4,
    //     "addedDesc": "80%人的选择",
    //     "delete": false
    //   },
    //   {
    //     "id": 10,
    //     "rechargeName": "220",
    //     "addPoints": 220,
    //     "originalPrice": 1100,
    //     "salePrice": 599,
    //     "discountRate": 5.4,
    //     "addedDesc": "80%人的选择",
    //     "delete": false
    //   },
    //   { "id": 20, "rechargeName": "105", "addPoints": 105, "originalPrice": 525, "salePrice": 299, "discountRate": 5.7, "addedDesc": "", "delete": false },
    //   { "id": 30, "rechargeName": "33", "addPoints": 33, "originalPrice": 165, "salePrice": 99, "discountRate": 6, "addedDesc": "", "delete": false }];
    return (
      <div className="fillingMoney-wrap">
        <div className="container">
          <div className="top">
            <em>可用背调余额：</em>{pointSum}点
            {
              vipInfo.level > 3 && vipInfo.amount >= 1 &&
              <em className="vipTimes">您是招聘{vipInfo.levelDes}用户，<i>剩余{vipInfo.amount}次</i>免费查询负面信息的权益</em>
            }
          </div>
          <div className="content">
            <p className="prompt">
              充值背调点数，立享超值优惠
              {
                vipInfo.level > 3 && vipInfo.amount >= 1 && "，同时赠送“充值返点，免费访客，免费元宝”等成长权益"
              }
            </p>
            <ul>
              {
                rechargeList.map((item) => {
                  let flag = item.id === checkedData.id;
                  return (
                    <li className={flag && "active"} key={item.id} onClick={() => { this.handleSelectClick(item) }}>

                      <div className="item">
                        {/* {item.id === 5
                          &&
                          <img
                            style={{position: 'absolute',top:'-35px', left:'1px'}} 
                            src="//pic1.58cdn.com.cn/nowater/cxnomark/n_v23c3ec5b5f2e846039aa7b91734c41dc3.png"
                          />
                        } */}
                        {/* <div className="sheng">立省{item.originalPrice - item.salePrice}元</div> */}
                        <p className="title">{item.rechargeName}背调点数</p>
                        <p className="price">
                          <span>¥{item.salePrice}</span>
                          {/* <em>原价¥{item.originalPrice}</em> */}
                        </p>
                        {/* <p className="zhe">{item.discountRate}折</p> */}
                      </div>
                    </li>
                  )
                })
              }
            </ul>
            <div className="footer">
              <button className="btn" onClick={checkedData.salePrice && this.handleSubmitClick}>立即充值 {checkedData.salePrice && "(¥" + checkedData.salePrice + ")"}</button>
              <p>
                1. 充值点数可查看所有背调服务<br />
                2. 点数需在购买日起365天内使用，过期作废
              </p>
            </div>
          </div>

        </div>
        <ModalPop history={history}></ModalPop>
      </div>
    )
  }
  componentDidMount() {
    // 初次进来的时候如果是充值回退，弹出弹框
    const { setLoadingState } = this.props;
    this.getFillingMoneyData();
    if (this.orderId && this.orderId !== sessionStorage.getItem("orderId")) {
      setLoadingState(true);  // 开启loading
      this.forGetPayResult(this.orderId);
      sessionStorage.setItem("orderId", this.orderId);
    }
  }

  // 轮训函数
  forGetPayResult(orderId) {
    const { setPopData, setLoadingState } = this.props;
    getPayResult(orderId).then((res) => {
      if (res.status === "PENDING") {
        let timer = setTimeout(() => {
          this.forGetPayResult(orderId)
          clearTimeout(timer);
        }, 500);
        return;
      }
      let title = "充值"
      let flag = res.status === "SUCCESS";
      let popData = {
        isShowModal: true,
        isPayModal: false,
        isSuccess: flag,
        data: {
          title: flag ? `${title}成功` : `${title}失败`,
          text: flag ? `您已成功${title}${res.addPoints}点` : "请检查网络或重新支付",
          buttonText: flag ? "确定" : "关闭并重试"
        }
      }
      setLoadingState(false)  // 关闭loading
      setPopData(popData)
      this.getFillingMoneyData();
    }).catch(() => { })
  }

  getFillingMoneyData() {
    Promise.all([getRechargeList(), getPointSum()])
      .then((resArr) => {
        let rechargeList = resArr[0];
        let pointSum = resArr[1]
        this.setState({
          rechargeList,
          pointSum,
        })
      }).catch(() => { })
  }

  // 选择充值项
  handleSelectClick(checkedData) {
    this.setState({ checkedData })
  }

  // 充值提交
  handleSubmitClick() {
    let item = this.state.checkedData;
    let params = {
      clientType: 2,
      rechargeId: item.id,
      rechargeType: 1,
    }
    chargeAndPay(params).then((data) => {
      window.open(data, "_self")
      // console.log(data);
    }).catch(() => { })
  }
}

const mapState = (store) => {
  return {
    pointSum: store.verifyResult.pointSum,
    vipInfo: store.verifyResult.vipInfo,
  }
}
const mapDispatch = (dispatch) => {
  return {
    setPopData(data) {
      dispatch({
        type: "setPopData",
        data,
      })
    },
    setLoadingState(data) {
      dispatch({
        type: "setLoadingState",
        data
      })
    }
  }
}
export default connect(mapState, mapDispatch)(FillingMoney);